const initData = `
### Generating Standup Notes

**Yesterday**:

**Today**:


**Blockers**:

`;

export default initData;
